import * as React from "react";
import Dropdown from "../../Dropdown/Dropdown";
import Input from "../../Input-new/Input";
import Tags from "../../Tags/Tags";
import {Link} from "react-router";
import { getTenantSubcategoryMT, getTenantSubcategorySTNL } from "../../../utils";
import { dateToUsString } from "../../../date-converter";
import UploadFiles from "./UploadFiles";
import Checkbox from "../../CheckboxNew/Checkbox";

const items = [{
    label:'Marketing Package',
    name:'media_kit'
}];

const fileTypes = {
    Document: 'file',
    Photo: 'photo'
};

const photos = [{
    label: 'Photo 1',
    name: 'website_photo_1',
}, {
    label: 'Photo 2',
    name: 'website_photo_2',
}, {
    label: 'Photo 3',
    name: 'website_photo_3',
}, {
    label: 'Photo 4',
    name: 'website_photo_4',
}, {
    label: 'Photo 5',
    name: 'website_photo_5',
}];

const PropertyInfo = ({isAgent, data, handleChangeDropdown, handleChangeInput, handleChangeFile, getTenantsForTags, tenantTags, handleClick, viewMode, deleted, isReferral, isFinancing, isStriveFinancing, redirectToHscTracking, isOffMarket = false, isSeniorAgent, isExtraPayment, hideTransactionType = false }) => {
    const isSaleLeaseBack = data.sale_lease_back === 'Yes';
    let COE;
    if (isSaleLeaseBack && data.close_of_escrow && data.original_lease_term) {
        COE = new Date(data.close_of_escrow);
        COE.setFullYear(COE.getFullYear()+parseInt(data.original_lease_term))
        const ledYear= COE.getFullYear();
        const lcdYear= new Date(data.close_of_escrow).getFullYear();
        let year = ledYear ||  lcdYear;      
        if(ledYear <lcdYear){
            year = lcdYear;
        }          
        let month = COE.getMonth();
        var lastDay = new Date(year, COE.getMonth(), 0).getDate();
        if(COE.getDate()>14){      
            month = month+2;
            if(month==13){
                month=1;
                year = year+1;
            }
            
            lastDay = new Date(year, COE.getMonth() + 2, 0).getDate();
        }else{
            if(month<1){
                month=12;
                year = year-1;
            }
        }
        const _value = month+"/"+lastDay+"/"+year;
        COE = dateToUsString(new Date(_value));
    }

    return (
        <div className="Property-info">
            <div className="Property-info_column">
            <div className="property-name-section">
                    <label className="Property-info_property-name-label">
                        Property Name     
                        <Checkbox 
                            text="Hot List"
                            type={viewMode ? "uncheckable" : "checkable"}
                            isSelected={data.hot_list === "1"} 
                            handleClick={() => handleClick("hot_list")} 
                            name="hot_list"
                        />                       
                    </label>
                    <Input
                    className="Property-info_column_item minHeight66"
                    required
                    valueType="text"
                    name="name"
                    value={
                        viewMode && data.media_kit ?
                            <Link className="green" target='_blank' to={data.media_kit.includes('https') ? data.media_kit : arc.path.media + data.media_kit }> 
                                {data.name}
                            </Link>
                        :
                            data.name
                    }
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                /> 
                </div>
                {/* <Input
                    className="Property-info_column_item"
                    required
                    valueType="text"
                    name="name"
                    label="Property Name"
                    value={
                        viewMode && data.media_kit ?
                            <Link className="green" target='_blank' to={arc.path.media + data.media_kit}>
                                {data.name}
                            </Link>
                        :
                            data.name
                    }
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                /> */}

                {
                    data.flip_book_link && (
                        <Input
                    className="Property-info_column_item"
                    valueType="text"
                    name="flip_book_link"
                    label="Flipbook Link"
                    value={
                       <Link className="green" target='_blank' to={data.flip_book_link } style={{ position: 'relative', top: '-5px' }}> 
                                {`${data.name} - ${data.city ? data.city : ''}, ${data.state ? data.state : ''}`}
                            </Link>
                    }
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                    ) 
                }
                {   
                    !isExtraPayment && <div>
                <Input
                    className="Property-info_column_item"
                    valueType="text"
                    name="address"
                    required={isSeniorAgent ? true : false}
                    label="Address"
                    value={
                        viewMode ?
                            data.latitude && data.longitude ?
                                <Link className="green" target="_blank" to={{
                                      pathname: "/map/" + data.arcimedes_row_id,
                                      query: {zoom: 18, mapTypeId: "satellite"},
                                  }}>
                                    {data.address}
                                </Link>
                                :
                                <a className="green" target="_blank" href={`http://maps.google.com/?q=${data.address}+${data.city}+${data.state}`}>
                                    {data.address}
                                </a>
                            :
                            data.address
                    }
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                </div>
                }
                <Input
                    className="Property-info_column_item"
                    valueType="text"
                    name="city"
                    required={isSeniorAgent ? true : false}
                    label="City"
                    value={data.city}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Dropdown
                    className="Property-info_column_item"
                    data={data}
                    isFromProperty
                    optionsType="states"
                    optionKey="abbr"
                    optionLabelKey="name"
                    value={data.state}
                    valueKey="state"
                    label="State"
                    required={isSeniorAgent ? true : false}
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />  
                {   
                    !isExtraPayment && <div>               
                <Input
                className="Property-info_column_item"
                valueType="text"
                name="zip"
                label="Zip"
                value={data.zip}
                required={isSeniorAgent ? true : false}
                disabled={isAgent}
                handleParentChange={handleChangeInput}
                viewMode={viewMode}
                deleted={deleted}
                /> </div>
                }
                
                {
                    !isReferral && !isOffMarket && !isExtraPayment &&
                    <Input
                        className="Property-info_column_item"
                        valueType="text"
                        name="year_built"
                        label="Year Built"
                        value={data.year_built}
                        disabled={isAgent}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                }
            </div>
            <div className="Property-info_column">
                {
                    isOffMarket &&
                    <Dropdown
                        optionKey='code'
                        className="Property-info_column_item"
                        data={data}
                        isFromProperty
                        optionsType="status"
                        value={data.status}
                        valueKey="status"
                        label="Status"
                        disabled={isAgent}
                        handleParentChange={handleChangeDropdown}
                        viewMode={viewMode}
                        deleted={deleted}
                        isOffMarket={true}
                    />
                }
                {/* <Dropdown
                    className="Property-info_column_item"
                    data={data}
                    isFromProperty
                    optionsType="source"
                    value={data.source}
                    required={isSeniorAgent ? true : false}
                    valueKey="source"
                    label="Source"
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                /> */}
                <Dropdown
                    className="Property-info_column_item"
                    data={data}
                    isFromProperty
                    optionsType="source"
                    value={data.source}
                    required={isSeniorAgent ? true : false}
                    valueKey="source"
                    label="Source"
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                    optionKey='code'
                    optionLabelKey='name'
                />
                {/* <Dropdown
                    className="Property-info_column_item"
                    data={data}
                    isFromProperty
                    optionsType="transaction"
                    required={isSeniorAgent ? true : false}
                    value={data.transaction_type}
                    valueKey="transaction_type"
                    label="Transaction Type"
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                /> */}
                {!hideTransactionType &&(
                  <Dropdown
                    className="Property-info_column_item"
                    data={data}
                    isFromProperty
                    optionsType="transaction"
                    required={isSeniorAgent ? true : false}
                    value={data.transaction_type}
                    valueKey="transaction_type"
                    label="Transaction Type"
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                )}
                {
                !isExtraPayment &&
                <Dropdown
                    className="Property-info_column_item"
                    data={data}
                    isFromProperty
                    optionsType="market"
                    optionKey='code'
                    optionLabelKey='name'
                    value={data.market}
                    required={isSeniorAgent ? true : false}
                    valueKey="market"
                    label="Market"
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                }

                {
                    !isReferral && !isOffMarket  && !isExtraPayment &&
                    <Input
                        className="Property-info_column_item"
                        valueType="integer"
                        name="sqft"
                        label="Square Feet"
                        value={data.sqft}
                        disabled={isAgent}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        withCommas
                    />
                }

          {isSeniorAgent && data.source === "External" && (
            <React.Fragment>
              <UploadFiles
                classNames="Property-info_column_item"
                data={data}
                viewMode={viewMode}
                deleted={deleted}
                handleChangeFile={handleChangeFile}
                maxFilesAmount={items.length}
                items={items}
                disabled={isAgent}
                canUploadManually
                handleChangeInput={handleChangeInput}
              />
            </React.Fragment>
          )}
          <div className="Website_column">
            {isSeniorAgent &&
              ((data.source === "STRIVE" && data.status == "Proposal") ||
                data.source === "External") && (
                <React.Fragment>
                  <UploadFiles
                    classNames="Website_column_item"
                    data={data}
                    viewMode={viewMode}
                    deleted={deleted}
                    handleChangeFile={handleChangeFile}
                    maxFilesAmount={photos.length}
                    items={photos}
                    disabled={isAgent}
                    fileType={fileTypes.Photo}
                  />{" "}
                </React.Fragment>
              )}
          </div>
        </div>
        <div className="Property-info_column">
          {!isExtraPayment && (
            <Dropdown
              className="Property-info_column_item"
              optionKey="code"
              optionLabelKey="name"
              data={data}
              required={isSeniorAgent ? true : false}
              isFromProperty
              optionsType="category"
              value={data.category}
              valueKey="category"
              label="Property Category"
              disabled={isAgent}
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
            />
          )}
          {data.category == "apartments" && (
            <div>
              <Dropdown
                className="Property-info_column_item"
                optionKey="code"
                optionLabelKey="name"
                data={data}
                isFromProperty
                optionsType="subcategory"
                value={data.sub_category}
                valueKey="sub_category"
                label="Sub Category"
                disabled={isAgent}
                handleParentChange={handleChangeDropdown}
                viewMode={viewMode}
                deleted={deleted}
              />
            </div>
          )}
          {data.category !== "apartments" && !isExtraPayment && (
            <Dropdown
              className="Property-info_column_item"
              optionKey="code"
              optionLabelKey="name"
              data={data}
              isFromProperty
              optionsType="type"
              required={isSeniorAgent ? true : false}
              value={data.type}
              valueKey="type"
              label="Property Type"
              disabled={isAgent}
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
            />
          )}
          {data.type === "STNL" &&
            data.category != "apartments" &&
            !isReferral &&
            !isFinancing &&
            getTenantSubcategorySTNL({
              data,
              handleChangeDropdown,
              viewMode,
              deleted,
              isFromProperty: true,
              disabled: isAgent,
              className: "Property-info_column_item",
            })}
          {data.type === "MT" &&
            data.category != "apartments" &&
            !isReferral &&
            !isFinancing &&
            getTenantSubcategoryMT({
              data,
              handleChangeDropdown,
              viewMode,
              deleted,
              isFromProperty: true,
              disabled: isAgent,
              className: "Property-info_column_item",
            })}
          {isOffMarket && (
            <React.Fragment>
              {isFinancing ? (
                <Input
                  className="Property-info_column_item"
                  type="text"
                  valueType="integer"
                  name="hsc_price"
                  label="Price"
                  value={data.hsc_price}
                  disabled={isAgent}
                  handleParentChange={handleChangeInput}
                  viewMode={viewMode}
                  deleted={deleted}
                  isDollar
                />
              ) : (
                <Input
                  className="Property-info_column_item"
                  type="text"
                  valueType="integer"
                  name="list_price"
                  label="List Price"
                  value={data.list_price}
                  disabled={isAgent}
                  handleParentChange={handleChangeInput}
                  viewMode={viewMode}
                  deleted={deleted}
                  isDollar
                />
              )}
              <Input
                className="Property-info_column_item"
                type="text"
                valueType="percent"
                name="capitalization_rate"
                label="Cap Rate"
                value={data.capitalization_rate}
                handleParentChange={handleChangeInput}
                viewMode={viewMode}
                deleted={deleted}
              />
            </React.Fragment>
          )}
          {data.type === "STNL" &&
            !isReferral &&
            !isFinancing &&
            !isOffMarket &&
            data.category != "apartments" && (
              <React.Fragment>
                <Dropdown
                  className="Property-info_column_item"
                  data={data}
                  isFromProperty
                  optionsType="lease"
                  value={data.lease_type}
                  valueKey="lease_type"
                  label="Lease Type"
                  disabled={isAgent}
                  handleParentChange={handleChangeDropdown}
                  viewMode={viewMode}
                  deleted={deleted}
                />
                {isSaleLeaseBack &&
                !data.name.includes("Christian Brothers Automotive") ? (
                  <React.Fragment>
                    <Input
                      className="Property-info_column_item"
                      placeholder="MM/DD/YYYY"
                      type="text"
                      name="lease_commencement_date"
                      label="Lease Commencement Date"
                      value={
                        data.close_of_escrow
                          ? data.close_of_escrow
                          : "At Close of Escrow"
                      }
                      disabled={true}
                      viewMode={viewMode}
                      deleted={deleted}
                    />
                    <Input
                      className="Property-info_column_item"
                      placeholder="MM/DD/YYYY"
                      type="text"
                      name="lease_expiration_date"
                      label="Lease Expiration Date"
                      value={
                        COE
                          ? COE
                          : `${
                              data.original_lease_term
                                ? data.original_lease_term + " Years from COE"
                                : "-"
                            }`
                      }
                      disabled={true}
                      viewMode={viewMode}
                      deleted={deleted}
                    />
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Input
                      className="Property-info_column_item"
                      placeholder="MM/DD/YYYY"
                      type="text"
                      valueType="date"
                      name="lease_commencement_date"
                      label="Lease Commencement Date"
                      value={data.lease_commencement_date}
                      disabled={isSaleLeaseBack ? true : isAgent}
                      handleParentChange={handleChangeInput}
                      viewMode={viewMode}
                      deleted={deleted}
                    />
                    <Input
                      className="Property-info_column_item"
                      placeholder="MM/DD/YYYY"
                      type="text"
                      valueType="date"
                      name="lease_expiration_date"
                      label="Lease Expiration Date"
                      value={data.lease_expiration_date}
                      disabled={isSaleLeaseBack ? true : isAgent}
                      handleParentChange={handleChangeInput}
                      viewMode={viewMode}
                      deleted={deleted}
                    />
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          {data.type === "MT" &&
            !isReferral &&
            !isFinancing &&
            !isOffMarket &&
            tenantTags &&
            tenantTags.length > 0 && (
              <Tags
                className="Property-info_column_item"
                values={tenantTags.map((tag) => tag.name)} 
                label="Tenant"
                deleted={deleted}
              />
            )}
          {isFinancing && !isOffMarket && (
            <UploadFiles
              classNames="Property-info_column_item"
              data={data}
              viewMode={viewMode}
              deleted={deleted}
              handleChangeFile={handleChangeFile}
              maxFilesAmount={items.length}
              items={items}
              disabled={isAgent}
              canUploadManually
              handleChangeInput={handleChangeInput}
            />
          )}
          {!isAgent &&
            (isFinancing || isStriveFinancing) &&
            ["Loan In Process"].includes(data.hsc_status) &&
            !isOffMarket && (
              <button
                type="button"
                className="button-new positive"
                onClick={redirectToHscTracking}
              >
                HSC Tracking
              </button>
            )}
        </div>
      </div>
    );
};

export default PropertyInfo;
